import React from 'react';

import './Menu.scss';

import MenuSide from './MenuSide/MenuSide';

 const Menu = (props) => {
    const { dispatch } = props;

    if (props.menuSideView) {
           return (
            <div className="Menu">
                
                    <MenuSide 
                    accountData={props.accountData}
                    chooseCategory={props.chooseCategory}
                    authData={props.authData}
                    dispatch={dispatch}
                    selectedModule={props.selectedModule}
                    menuSideView={props.menuSideView}
                    />
                
            </div>
            )
        }
   }
   export default Menu;